import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";
import { statusData } from "./dataColor";

const RfxColumnChart = ({ chartdata }) => {
  const chartRef = useRef(null);
// eslint-disable-next-line 
  const seriesData = chartdata?.series || [];
  // eslint-disable-next-line 
  const categoriesData = chartdata?.categories || [];

  const colors = seriesData.map((series) => {
    const status = statusData.find((item) => item.message === series.name);
    return status?.color || "#808080";  // fallback color
  });

  useEffect(() => {
    if (!chartRef.current) return;

    const options = {
      series: seriesData,
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "65%",
          borderRadius: 5,
        },
      },
      colors,
      xaxis: {
        categories: categoriesData,
      },
      dataLabels: { enabled: false },
      stroke: { show: true, width: 2, colors: ["transparent"] },
      fill: { opacity: 1 },
      tooltip: {
        y: { formatter: (val) => `Count ${val}` },
      },
    };

    const chart = new ApexCharts(chartRef.current, options);
    chart.render();

    return () => chart.destroy();
  }, [seriesData, categoriesData, colors]);

  return <div id="rfxColumnChart" ref={chartRef}></div>;
};

export default RfxColumnChart;
